import Page from 'src/components/page/page';
import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import BandForm from './components/band-form';
import useHomeBandsDetails from './home-bands.hook';

export default function HomeBandDetails() {
  const hook = useHomeBandsDetails();
  return (
    <Page title={hook.isEdit ? 'Editar Faixa' : 'Cadastrar Faixa'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={hook.isEdit ? 'Editar Faixa' : 'Cadastrar Faixa'}
          links={[]}
        />
        {hook.isLoadingDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <BandForm hook={hook} />
        )}
      </Container>
    </Page>
  );
}
